import { useState, useEffect } from "react";
import { getTranslations } from "@lironsheli/website-content";
import { Button } from "ui/compat";
import { ConcentWrapper } from "styles";
import { legalPageUrl } from "util/legalPages";
import {
  getCookieConsentFromDocument,
  setCrossDomainCookieConsent,
} from "util/cookieConsentCrossDomain";

export const CookieConsent = ({ language = "en" }) => {
  const [showConsent, setShowConsent] = useState(false);
  const t = getTranslations(language).cookieConsent;

  useEffect(() => {
    const fromCookie = getCookieConsentFromDocument();
    if (fromCookie === "accepted" || fromCookie === "rejected") {
      try {
        const ls = localStorage.getItem("cookieConsent");
        if (ls !== fromCookie) {
          localStorage.setItem("cookieConsent", fromCookie);
          localStorage.setItem(
            "cookieConsent.updatedAt",
            new Date().toISOString(),
          );
        }
      } catch {
        /* ignore */
      }
      setShowConsent(false);
      return;
    }

    try {
      const ls = localStorage.getItem("cookieConsent");
      if (ls === "accepted" || ls === "rejected") {
        setCrossDomainCookieConsent(ls);
        setShowConsent(false);
        return;
      }
    } catch {
      /* ignore */
    }

    setShowConsent(true);
  }, []);

  const handleAccept = () => {
    setCrossDomainCookieConsent("accepted");
    setShowConsent(false);
  };

  const handleReject = () => {
    setCrossDomainCookieConsent("rejected");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <ConcentWrapper role="dialog" aria-label={t.title}>
      <div className="ls-cookie-consent-copy">
        <h6>{t.title}</h6>
        <p>
          {t.messagePage}{" "}
          <a
            href={legalPageUrl("privacyPolicy")}
            rel="noreferrer"
            target="_blank"
          >
            {t.readMore}
          </a>
        </p>
      </div>

      <div className="ls-cookie-consent-actions">
        <Button basic size="small" onClick={handleReject}>
          {t.reject}
        </Button>
        <Button primary size="small" onClick={handleAccept}>
          {t.accept}
        </Button>
      </div>
    </ConcentWrapper>
  );
};
